import sanctionedCountryQuestions from "constants/sanctionedCountryQuestions";

export const isSanctionedCountryQuestionsRequired = (countries: string[]) =>
  countries.some((country) => sanctionedCountryQuestions[country] !== undefined);
